import { useState } from 'react'
import { useAdmin } from '../context/AdminContext'
import { useNavigate } from 'react-router-dom'

function AdminLogin() {
  const { signIn } = useAdmin()
  const navigate = useNavigate()
  const [form, setForm] = useState({ email: '', password: '' })
  const [error, setError] = useState('')
  const [loading, setLoading] = useState(false)

  const handleLogin = async () => {
    if (!form.email || !form.password) {
      setError('Please fill in all fields')
      return
    }
    setLoading(true)
    setError('')
    const { error } = await signIn({ email: form.email, password: form.password })
    if (error) {
      setError(error)
      setLoading(false)
    } else {
      navigate('/admin/dashboard')
    }
  }

  return (
    <div className="min-h-screen bg-gray-100 flex items-center justify-center p-4">
      <div className="bg-white rounded-2xl shadow-sm w-full max-w-sm overflow-hidden border border-gray-200">
        <div className="bg-blue-600 px-6 py-8 text-center">
          <div className="text-2xl font-bold text-white mb-1">PageConnect</div>
          <div className="text-blue-200 text-sm">Admin Panel</div>
        </div>
        <div className="p-6">
          <div className="text-lg font-semibold text-gray-800 mb-1">Admin sign in</div>
          <div className="text-xs text-gray-400 mb-6">🔒 Authorized team members only</div>

          {error && (
            <div className="bg-red-50 border border-red-200 text-red-600 text-xs rounded-lg px-4 py-3 mb-4">
              {error}
            </div>
          )}

          <div className="mb-3">
            <label className="text-xs text-gray-500 font-medium mb-1 block">Email address</label>
            <input type="email" value={form.email}
              onChange={e => setForm(f => ({ ...f, email: e.target.value }))}
              placeholder="your@pageconnect.com"
              className="w-full bg-gray-100 border border-gray-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-blue-400" />
          </div>
          <div className="mb-6">
            <label className="text-xs text-gray-500 font-medium mb-1 block">Password</label>
            <input type="password" value={form.password}
              onChange={e => setForm(f => ({ ...f, password: e.target.value }))}
              placeholder="••••••••"
              onKeyDown={e => e.key === 'Enter' && handleLogin()}
              className="w-full bg-gray-100 border border-gray-200 rounded-lg px-3 py-2.5 text-sm outline-none focus:border-blue-400" />
          </div>

          <button onClick={handleLogin} disabled={loading}
            className="w-full bg-blue-600 text-white py-3 rounded-xl text-sm font-semibold hover:bg-blue-700 disabled:opacity-50 transition-colors">
            {loading ? 'Signing in...' : 'Sign in to admin'}
          </button>
        </div>
      </div>
    </div>
  )
}

export default AdminLogin